import TableCell from '@material-ui/core/TableCell';
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import startCase from 'lodash.startcase';

const useStyles = makeStyles((theme: any) => ({
  statusCell: {
    whiteSpace: 'pre',
    textAlign: 'center',
    fontStyle: ({ paymentStatus }: any) => {
      return paymentStatus === 'review' ? 'italic' : 'normal';
    },
    fontWeight: ({ status }: any) => {
      return ['queued', 'failed', 'paused'].includes(status)
        ? 'bold'
        : 'normal';
    },
  },
  italicFont: { fontStyle: 'italic' },
}));

export default function PaymentStatus({
  status,
  paymentStatus,
  adjustBalanceRow,
  calculateStatus,
}) {
  const classes = useStyles({ status, paymentStatus });

  return (
    <TableCell padding="none" className={classes.statusCell}>
      {['review', 'pending_customer_approval'].includes(paymentStatus)
        ? `${startCase(calculateStatus({ adjustBalanceRow, status }))} \n (${
            paymentStatus === 'review' ? 'Request Sent' : 'Pending Approval'
          })`
        : startCase(calculateStatus({ adjustBalanceRow, status }))}
    </TableCell>
  );
}
